<template>
  <section class="site-hero-banner">
    <div class="site-hero-banner__wrapper">
      <div class="site-hero-banner__wrapper__description">
        <h1 class="site-hero-banner__wrapper__description__title">
          CRA en ligne gratuit pour freelances en régie
        </h1>
        <p class="site-hero-banner__wrapper__description__subtitle">
          Générez votre Compte Rendu d'Activité en quelques clics. Signature électronique, validation par le client, export PDF. Gratuit et illimité.
        </p>
        <SiteButton
          class="site-hero-banner__wrapper__description__button"
          label="Créer mon CRA"
          has-arrow
          @click="$router.push({ name: 'app' })"
        />
        <p class="site-hero-banner__wrapper__description__sub">
          Gratuit et illimité. Votre premier CRA en 2 minutes.
        </p>
      </div>
      <div class="site-hero-banner__wrapper__illustration">
        <img
          alt="Illustration d'un freelance générant son CRA en ligne"
          class="site-hero-banner__wrapper__illustration__img"
          src="./image.svg"
        />
      </div>
    </div>
  </section>
  
</template>

<script setup>
  import SiteButton from '@/components/SiteButton'

  const emit = defineEmits(['hash'])
</script>
<style lang="scss">
  @use './index.scss';
</style>